
const Mission = () => {
  return (
    <section id="mission" className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              Our Mission & Vision
            </h2>
            <div className="space-y-6">
              <div>
                <h3 className="text-xl font-semibold text-teal-600 mb-3">Mission Statement</h3>
                <p className="text-gray-600 leading-relaxed">
                  To provide accessible, fair, and comprehensive financial services to immigrants and residents 
                  in Calgary, fostering economic empowerment and community integration through cooperative principles 
                  and financial literacy education.
                </p>
              </div>
              <div>
                <h3 className="text-xl font-semibold text-teal-600 mb-3">Our Vision</h3>
                <p className="text-gray-600 leading-relaxed">
                  To be Calgary's leading cooperative financial institution, recognized for our commitment to 
                  diversity, inclusion, and community development, where every member has the opportunity to 
                  achieve financial stability and prosperity.
                </p>
              </div>
            </div>
          </div>
          <div className="relative">
            <img
              src="https://public.readdy.ai/ai/img_res/b723c55a747cbd91c5cd192036aefb61.jpg"
              alt="Landmark Cooperative Mission"
              className="rounded-xl shadow-lg object-cover w-full h-96"
            />
          </div>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="text-center">
            <div className="w-16 h-16 bg-teal-100 text-teal-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-community-line text-2xl"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">Community First</h3>
            <p className="text-gray-600">
              We prioritize the needs of our community members, ensuring that our services are designed 
              to support local economic growth and individual prosperity.
            </p>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 bg-teal-100 text-teal-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-global-line text-2xl"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">Inclusive Excellence</h3>
            <p className="text-gray-600">
              We celebrate diversity and create an inclusive environment where immigrants and long-term 
              residents alike can access the financial services they need.
            </p>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 bg-teal-100 text-teal-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-lightbulb-line text-2xl"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">Financial Education</h3>
            <p className="text-gray-600">
              We believe in empowering our members through comprehensive financial literacy programs 
              and ongoing educational support.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Mission;
